// var HttpStatus = require('http-status-codes');

const state = {
  guestToken: localStorage.getItem('guest-token') || '',
  role: localStorage.getItem('role') || '',
  token: localStorage.getItem('user-token') || '',
  status: '',
  error: '',
  isWorker: !!localStorage.getItem('isWorker'),
  username: localStorage.getItem('username') || '',
  isAuthenticated: !!localStorage.getItem('user-token'),
};


const getters = {
  authStatus: state => state.status,
  is_authenticate: state => {
    return state.isAuthenticated;
  },
};

const actions = {


  AUTH_LOGOUT: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      let token = localStorage.getItem('user-token');
      fetch(process.env.VUE_APP_AUTH_URL_LOGOUT, {
        method: 'post',
        headers: {
          'Authorization': 'Token ' + token
        }
      });
      commit('AUTH_LOGOUT');
      localStorage.removeItem('user-token'); // clear your user's token from localstorage
      localStorage.removeItem('isWorker');
      localStorage.removeItem('role');
      localStorage.removeItem('guest-token');
      localStorage.removeItem('username');
      window.$cookies.remove("userMuctr");
      resolve()
    })
  },

  AUTH_GUESTTOKEN:({commit, dispatch}, guestToken) => {
    localStorage.setItem('guest-token', guestToken);
    commit('AUTH_GUESTTOKEN',{guestToken:guestToken});
  },

  CLEAR_GUESTTOKEN:({commit, dispatch}) => {
    localStorage.removeItem('guest-token');;
    commit('CLEAR_GUESTTOKEN');
  },

  AUTH_ROLE:({commit, dispatch}, role) => {
    localStorage.setItem('role', role);
    commit('AUTH_ROLE',{role:role});
  }
};

const mutations = {
  AUTH_ROLE: (state, {role}) => {
    state.role = role;
  },
  AUTH_LOGOUT: (state) => {
    state.status = 'logout';
    state.error = null;
    state.isAuthenticated = false;
    state.token = '';
    state.role = '';
    state.guestToken = '';
    state.username = '';
    state.isWorker = false;
  },

  AUTH_SUCCESS: (state, {token, username}) => {
    state.status = 'success';
    state.token = token;
    state.username = username;
    state.isAuthenticated = true;
    state.isWorker = false;
    //console.log(state)
  },
  AUTH_GUESTTOKEN: (state, {guestToken}) => {
    state.guestToken = guestToken;
    state.isAuthenticated = false;
  },
  CLEAR_GUESTTOKEN: (state) => {
    state.guestToken = '';
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
